import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    getCart, subscribe as subscribeCart, setQty, removeItem, clearCart, getTotal
} from "../cart/cart";
import {PAYMENT, SHIPPING} from "../api/config";

function formatPrice(n){ return new Intl.NumberFormat("sk-SK",{style:"currency",currency:"EUR"}).format(n||0); }
function imgOrPlaceholder(u){ return u || "/images/placeholder.jpg"; }


export default function CartPage(){
    var navigate = useNavigate();
    var [cart, setCart] = useState(getCart());
    var total = getTotal();
    const [ship, setShip] = useState("kurier");
    const [pay,  setPay]  = useState("kartou");

    const shippingCost = SHIPPING[ship].price;
    const paymentFee   = PAYMENT[pay].price;
    const grand        = total + shippingCost + paymentFee;


    useEffect(function(){
        var unsub = subscribeCart(function(){ setCart(getCart()); });
        return () => unsub();
    }, []);

    if (!cart.items.length){
        return (
            <div className="container py-4">
                <h1 className="h4 mb-3">Košík</h1>
                <div className="alert alert-light border">
                    V košíku zatiaľ nič nie je.
                </div>
                <Link to="/ponuka" className="btn btn-brown rounded-pill">Prejsť na ponuku</Link>
            </div>
        );
    }

    return (
        <div className="container py-4">
            <h1 className="h4 mb-4">Košík</h1>

            <div className="row g-4">
                <div className="col-lg-8">
                    <ul className="list-group">
                        {cart.items.map(function(it){
                            return (
                                <li key={it.id} className="list-group-item">
                                    <div className="d-flex align-items-center gap-3">
                                        <img src={imgOrPlaceholder(it.imageUrl)} alt={it.name}
                                             onError={e=> e.currentTarget.src="/images/placeholder.jpg"}
                                             width="80" height="80" style={{objectFit:"cover"}} />
                                        <div className="flex-grow-1">
                                            <div className="fw-semibold">{it.name}</div>
                                            <div className="text-muted small">{formatPrice(it.price)}</div>
                                        </div>

                                        <div className="d-sm-flex align-items-center gap-2">
                                            <div className="input-group" style={{width: 130}}>
                                                <button className="btn btn-outline-danger"
                                                        onClick={()=> setQty(it.id, it.qty - 1)}
                                                        title="Menej">−</button>
                                                <input className="form-control text-center"
                                                       type="number" min="0"
                                                       value={it.qty}
                                                       onChange={e=> setQty(it.id, e.target.value)} />
                                                <button className="btn btn-outline-success"
                                                        onClick={()=> setQty(it.id, it.qty + 1)}
                                                        title="Viac">+</button>
                                            </div>

                                            <div className="text-end" style={{width:120}}>
                                                <div className="fw-semibold">{formatPrice(it.price * it.qty)}</div>
                                                <button className="btn btn-link text-danger p-0"
                                                        onClick={()=> removeItem(it.id)}>
                                                    odstrániť
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>

                    <div className="d-flex justify-content-between mt-3">
                        <Link to="/ponuka" className="btn btn-outline-secondary rounded-pill">Pokračovať v nákupe</Link>
                        <button className="btn btn-outline-danger rounded-pill" onClick={clearCart}>Vyprázdniť košík</button>
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-2">
                                <span>Medzisúčet</span>
                                <span className="fw-semibold">{formatPrice(total)}</span>
                            </div>
                            <hr />
                            <button className="btn btn-brown w-100" onClick={()=> navigate("/objednavka")}>
                                Pokračovať k objednávke
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
